import { Navigate } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import AuthLoadingScreen from "./AuthLoadingScreen";

const TenantGuard = ({ children }) => {
  const { isAuthenticated, isInitializing, isTenantResolved, user, tenant, bootstrapError } = useStateContext();

  if (isInitializing) return <AuthLoadingScreen />;
  if (bootstrapError) return <AuthLoadingScreen error={bootstrapError} />;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (user?.role === "super_admin") return <Navigate to="/super-admin" replace />;
  if (user?.role !== "Admin") return <Navigate to="/" replace />;
  if (!isTenantResolved) {
    return <AuthLoadingScreen error="This account is not connected to an available tenant. Contact your system administrator." />;
  }
  if (tenant?.expires_at && new Date(tenant.expires_at).getTime() < Date.now()) {
    return <AuthLoadingScreen error="This tenant subscription has expired. Contact your system administrator." />;
  }

  return children;
};

export default TenantGuard;